<template>
<span>
    <div class="header-tool__overlay" v-if="showCopyWindow" @click="showCopyWindow=false"></div>
    <el-popover
        class="share"
        :visible-arrow="false"
        placement="bottom-start"
        v-model="showCopyWindow"
    >
        <span slot="reference" class="share-icon-wrapper">
            <el-button class="btn" type="text" title="Share room link">
                <IconBase
                    :height="24"
                    :width="24"
                    :fill="showCopyWindow ? '#50C6DF' : '#E7E6FA'"
                    name="share-alt"
                    class="share-icon"
                >
                    <IconShare />
                </IconBase>
            </el-button>
        </span>

            <div v-if="showCopyWindow" width="35%" class="header-tool__popup">
                <div class="header-tool__header">
                    <h3>Share room link</h3>
                    <div @click="showCopyWindow=false">
                        <IconBase
                            :height="24"
                            :width="24"
                            :view-box="`0 0 24 24`"
                            :fill="'#E7E6FA'"
                        >
                            <IconCross />
                        </IconBase>
                    </div>
                </div>
                <div class="header-tool__body">
                    <el-form>
                        <p for="url">Copy the room link to share.</p>
                        <div class="copy__container">
                            <el-tooltip effect="dark" :content="copied?'Copied to clipboard':'Copy'" placement="top">
                                <div class="copy-icon" v-clipboard:copy="shareUrl" v-clipboard:success="onCopy" v-clipboard:error="resetCopyStatus" @mouseenter="resetCopyStatus">
                                    <IconBase
                                        :height="24"
                                        :width="24"
                                        :view-box="`0 0 24 24`"
                                        :fill="'#E7E6FA'"
                                    >
                                        <IconCopy />
                                    </IconBase>
                                </div>
                            </el-tooltip>
                            <el-input :value="shareUrl" id="url" disabled></el-input>
                        </div>
                    </el-form>
                </div>
                <div class="header-tool__footer">
                    <el-button size="small" @click="showCopyWindow=false">Cancel</el-button>
                    <el-button size="small" type="primary" @click="showCopyWindow=false">Done</el-button>
                </div>
            </div>
    </el-popover>
</span>
</template>

<script>
import IconBase from '../IconBase';
import IconShare from '../icons/IconShare'
import IconCross from '../icons/IconCross'
import IconCopy from '../icons/IconCopy'

export default {
    name: "Share",
    components: {
        IconBase,
        IconShare,
        IconCross,
        IconCopy
    },
    data: function () {
        return {
            shareUrl: window.location.href,
            copied: false,
            showCopyWindow: false,
        }
    },
    methods: {
        onCopy() {
            this.copied = true;
        },
        resetCopyStatus() {
            this.copied = false;
        }
    },
    watch: {
        '$route'() {
            this.shareUrl = window.location.href
        }
    }
};
</script>

<style scoped>
.btn {
    padding: 7px;
}

.copy__container {
    display: flex;
}
.copy-icon {
    margin-right: 12px;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 24px;
    height: 24px;
    padding: 4px;
    background: #3E3E52;
    box-shadow: 0px 3px 4px rgba(0, 0, 0, 0.14), 0px 3px 3px rgba(0, 0, 0, 0.12), 0px 1px 8px rgba(0, 0, 0, 0.2);
    border-radius: 4px;
}

>>>.header-tool__overlay {
    position: fixed;
    top: 0;
    left: 0;
    height: 100vh;
    width: 100vmax;
    background: #000;
    opacity: 0.5;
    z-index: 15;
}
>>>.header-tool {
    position: relative;
}
>>>.header-tool__popup {
    position: absolute;
    padding: 0 12px;
    z-index: 1;
    background: #2A2A3D;
    box-shadow: 0px 3px 4px rgba(0, 0, 0, 0.14), 0px 3px 3px rgba(0, 0, 0, 0.12), 0px 1px 8px rgba(0, 0, 0, 0.2);
    border-radius: 8px;
    min-width: 320px;
    min-height: 177px;
    color: #E7E6FA;
}

>>>.header-tool__header {
    display: flex;
    justify-content: space-between;
    align-items: center;
}
>>>.header-tool__body {
    text-align: left;
    margin-bottom: 20px;
}
>>>.header-tool__footer {
    display: flex;
    justify-content: flex-end;
    padding: 20px 0;
}

>>>input.el-input__inner,
>>>.el-input.is-disabled .el-input__inner {
    background: #393752;
    border-radius: 3px;
    height: 32px;
    border: none;
    color: #E7E6FA;
}

>>>button.el-button--default,
>>>button.el-button--default:hover,
>>>button.el-button--default:active {
    height: 36px;
}

>>>button.el-button--primary,
>>>button.el-button--primary:hover,
>>>button.el-button--primary:active {
    height: 36px;
}

@media (max-width: 767px) {
    .share-icon-wrapper .btn {
        position: relative;
    }

    .share-icon-wrapper .btn[title]:hover:after{
        content: attr(title);
        display: none;
    }
}

@media (hover: none) {
    .share-icon-wrapper .btn {
        position: relative;
    }

    .share-icon-wrapper .btn[title]:hover:after{
        content: attr(title);
        display: none;
    }
}
</style>
